import { type ClassValue, clsx } from "clsx";
import { t } from "i18next";
import { twMerge } from "tailwind-merge";
import { env } from "@/env";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

export const item = {
  hidden: { y: 20, opacity: 0 },
  show: { y: 0, opacity: 1 },
};

export const getVisitTitle = (
  title: string | null | undefined,
  rowno: number | null,
): string => {
  return title || `${t("visits.visit")}${rowno === null ? "" : ` #${rowno}`}`;
};

export const formatTitle = (title: string = ""): string =>
  title ? `${title}. ` : "";

export const bytesToMegabytes = (bytes: number): number => {
  return bytes / (1024 * 1024);
};

export const isSafari = (): boolean => {
  return (
    /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)
  );
};

export const isFirefox = (): boolean => {
  return /Firefox/.test(navigator.userAgent);
};

export const roundPercentage = (value: number): number => {
  const percentage = Math.round(value * 10) / 10;
  return !Number.isFinite(percentage) || Number.isNaN(percentage)
    ? 0
    : percentage;
};

export const formatTimeMMSS = (seconds: number): string => {
  const minutes = String(Math.floor(seconds / 60)).padStart(2, "0");
  const secs = String(Math.floor(seconds % 60)).padStart(2, "0");
  return `${minutes}:${secs}`;
};

export const getBooleanEnv = (key: keyof typeof env): boolean => {
  return env[key] === "true";
};
